import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import * as moment from 'moment-timezone';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';

import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';

import { ModalServiceService } from '@core/services/modal-service.service';
import { UserProfileService } from '@core/services/user.service';

import { OnboardingService } from '../shared/services/onboarding.service';

@Component({
  selector: 'app-onboarding-timestamp',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    DropdownModule,
    ButtonModule,
    CommonModule,
    MessagesModule,
    MessageModule,
  ],
  templateUrl: './onboarding-timestamp.component.html',
  styleUrl: './onboarding-timestamp.component.scss',
})
export class OnboardingTimestampComponent {
  @Output() nextStep = new EventEmitter<any>(false);
  formGroup: FormGroup | undefined;
  timezoneList: any = [];
  selectedTimezone: any;
  msgs: any = [{ severity: 'error', detail: 'Please select Timezone' }];
  showError = false;
  isLoading = false;
  private destroy$ = new Subject<void>();

  constructor(
    private onboardingService: OnboardingService,
    private router: Router,
    private modelService: ModalServiceService,
    private userProfileService: UserProfileService
  ) {
    this.onboardingService.getAllTimezones().subscribe((timezones: any) => {
      for (const region in timezones) {
        for (const tz in timezones[region]) {
          const items = [];
          for (const item in timezones[region][tz]) {
            items.push({ label: item, value: item });
          }
          this.timezoneList.push({
            label: Object.keys(timezones[region][tz])[0],
            items,
          });
        }
      }
    });
  }

  ngOnInit() {
    this.formGroup = new FormGroup({
      selectedCity: new FormControl<any | null>(null),
    });
  }

  getUserCurrentTimeZone() {
    // eslint-disable-next-line import/namespace
    let timezone = moment.tz.guess();
    if (timezone === 'Asia/Calcutta') {
      timezone = 'Asia/Kolkata';
    }
    this.selectedTimezone = timezone;
    return timezone;
  }

  isUserTimezoneValid() {
    return this.timezoneList.reduce((result: any, country: { items: any[] }) => {
      if (result) return result;
      return country.items.find(
        (city) => city.label.toLowerCase() === this.getUserCurrentTimeZone().toLowerCase()
      );
    }, null);
  }

  updateUserTimeZone() {
    if (this.isLoading) {
      return;
    }
    if (this.isUserTimezoneValid()) {
      this.isLoading = true;
      this.onboardingService
        .updateUserTimezone({
          timezone: this.selectedTimezone,
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.skipOnboarding();
          },
          error: (err) => {
            this.modelService.openErrorModal(err.message);
            this.isLoading = false;
          },
        });
    } else {
      this.isLoading = false;
      this.showError = true;
    }
  }

  skipOnboarding() {
    const randomName = 'Confe_' + Math.random().toString(36).substring(2, 8);
    this.onboardingService
      .createWorkspace(randomName)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.onboardingService
            .setOnboardingForUser()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: () => {
                this.userProfileService
                  .getUserDetails()
                  .pipe(takeUntil(this.destroy$))
                  .subscribe({
                    next: () => {
                      this.userProfileService.setShowLaunchGuide(true);
                      this.router.navigate(['/'], { replaceUrl: true });
                    },
                    error: () => {
                      // Even if refresh fails, proceed with navigation
                      this.router.navigate(['/'], { replaceUrl: true });
                      this.isLoading = false;
                    },
                  });
              },
              error: (err) => {
                this.modelService.openErrorModal(err.message);
                this.isLoading = false;
              },
            });
        },
        error: (err) => {
          this.modelService.openErrorModal(err.message);
          this.isLoading = false;
        },
      });
  }
}
